import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProfileService } from '../services/profile-service';
import { take, map, filter } from 'rxjs';
import { IUser } from '../../constants/interface/profile';
import { ERole } from '../../constants/enum/role';

export function roleGuard(...allowedRoles: ERole[]): CanActivateFn {
  return () => {
    const profileService = inject(ProfileService);
    const router = inject(Router);

    const profile = profileService.profileData.value;

    if (profile) {
      if (allowedRoles.includes(profile.current_role?.role)) {
        return true;
      }
      router.navigate(['/profile']);
      return false;
    }

    return profileService.profileData.pipe(
      filter((p): p is IUser => p !== null),
      take(1),
      map(p => {
        if (p && allowedRoles.includes(p.current_role?.role)) {
          return true;
        }
        router.navigate(['/profile']);
        return false;
      })
    );
  };
}
